import { useAuthStore } from '../../utils/stores/useAuthStore';
import { useUserStore } from '../../utils/stores/useUserStore';

const CURRENT_VERSION = process.env.REACT_APP_PRIVACY_POLICY_CURRENT_VERSION || 'v2.0';

/**
 * Returns true when the logged-in user needs to re-accept the privacy policy.
 * Gates on: a real session (idToken + userId), userData has loaded (email present),
 * and the stored accepted version differs from the current build-time version.
 */
export const useConsentGate = (): { needsReacceptance: boolean } => {
    const { auth } = useAuthStore();
    const { userData } = useUserStore();

    const hasSession = !!auth.userId && !!auth.idToken;
    const userLoaded = !!userData.email;
    const needsReacceptance =
        hasSession && userLoaded && userData.acceptedPrivacyVersion !== CURRENT_VERSION;

    return { needsReacceptance };
};
